import Button from "@components/Button";
import { Modal } from "@components/Modal";
import { useApiConfirmarTermos } from "@hooks/api/common";
import useAuth from "@hooks/useAuth";
import { useConsultTerms } from "@hooks/useConsultTerms";
import { useCallback } from "react";
import { TextTermosTitle, TextTermsArea, TextTermos } from "./styles";

interface AcceptTermosModalProps {
  open: boolean;
  onClose: () => void;
}

export const AcceptTermosModal = ({
  open,
  onClose,
}: AcceptTermosModalProps) => {
  const [termsConfirm, { loading: loadingConfirmTerms }] =
    useApiConfirmarTermos();
  const { termsOfUse, privacyPolicy, loadingTermsData } = useConsultTerms();
  const { user } = useAuth();

  const fetchTermsConfirm = useCallback(async () => {
    try {
      await termsConfirm({
        data: {
          id: user?.id || 0,
          termo_uso_privacidade: true,
        },
      });
      onClose();
    } catch {
      // do nothing
    }
  }, [termsConfirm, user?.id, onClose]);

  return (
    <Modal
      title="Termos de Uso e Política de Privacidade"
      open={open}
      closable={false}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={() => void fetchTermsConfirm()}
          loading={loadingConfirmTerms}
        >
          Aceitar
        </Button>,
      ]}
      loading={loadingTermsData}
      width={800}
    >
      <h3>
        Para continuar, leia atentamente os termos abaixo. Ao clicar em
        &quot;Aceitar&quot;, você concorda com os Termos de Uso e a Política de
        Privacidade.
      </h3>

      <TextTermsArea>
        <TextTermosTitle>Termos de uso</TextTermosTitle>
        <TextTermos
          dangerouslySetInnerHTML={{
            __html: termsOfUse,
          }}
        />
        <TextTermosTitle>Política de privacidade</TextTermosTitle>
        <TextTermos
          dangerouslySetInnerHTML={{
            __html: privacyPolicy,
          }}
        />
      </TextTermsArea>
    </Modal>
  );
};
